import api from "../lib/apiClient";

export const getLeaderboard = () => api.get("/leaderboard").then((r) => r.data);

export const adminAddLeader = (data) => api.post("/admin/leaderboard", data).then((r) => r.data);

export const adminUpdateLeader = (id, data) => api.patch(`/admin/leaderboard/${id}`, data).then((r) => r.data);

export const adminDeleteLeader = (id) => api.delete(`/admin/leaderboard/${id}`).then((r) => r.data);

export const adminReorderLeaders = (orderedIds) => api.put("/admin/leaderboard/reorder", { ordered_ids: orderedIds }).then((r) => r.data);

export const adminResetLeaderboard = () => api.post("/admin/leaderboard/reset").then((r) => r.data);
